module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Autenticação de 2 fatores")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t10"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'UPDATE_USER_EMAIL' || _vm.type == 'UPDATE_NEW_USER_EMAIL') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.type == 'UPDATE_USER_PHONE' || _vm.type == 'UPDATE_NEW_USER_PHONE') ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.type == 'UPDATE_PASSWORD' || _vm.type == 'UPDATE_ACCOUNT' || _vm.type == 'RESET_PASSWORD') ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.type == 'SMS' || _vm.type == 'EMAIL') ? _c('div', [(_vm.type == 'SMS') ? _c('p', [_vm._v("Enviamos um código de 6 dígitos para o seu celular cadastrado. Para continuar, insira o código no campo abaixo:")]) : _vm._e(), _vm._v(" "), (_vm.type == 'EMAIL') ? _c('p', [_vm._v("Enviamos um código de 6 dígitos para o seu e-mail cadastrado. Para continuar, insira o código no campo abaixo:")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenInput),
      expression: "tokenInput"
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "tokenInput",
      "maxlength": "6",
      "type": "text",
      "name": "tokenInput",
      "placeholder": "Digite o código recebido",
      "data-vv-validate-on": "blur",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.tokenInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(""))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-purple ",
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button",
      "disabled": _vm.tokenInput.length == 6 ? false : true
    }
  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Enviamos um código de 6 dígitos para o seu "), _c('b', [_vm._v("e-mail")]), _vm._v(" cadastrado. Para continuar, insira o código\n                no campo abaixo:\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Enviamos um código de 6 dígitos para o seu "), _c('b', [_vm._v("celular")]), _vm._v(" cadastrado. Para continuar, insira o código\n                no campo abaixo:\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Enviamos um código de 6 dígitos para o seu "), _c('b', [_vm._v("celular")]), _vm._v("  e "), _c('b', [_vm._v("e-mail")]), _vm._v(" cadastrados. Para continuar, insira o código\n                no campo abaixo:\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-72815a02!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/2fa-interno.vue
// module id = 2167
// module chunks = 1